export default "/images/vendor/flag-icon-css/flags/1x1/mu.svg?d7d71f034d81a71053730203f958dca1";